import React from 'react'
import CartItems from '../Components/CartItems/CartItems'
import Formulario from '../Components/Formulario/Formulario'

const Carrito = () => {
  return (
    <div>
      <CartItems/>
      <Formulario />

    </div>
  )
}

export default Carrito
